import { StyledMarkdown } from "@hlcr/ui";
import { useIntl } from "@hlcr/ui/Intl";
import { useEffect } from "react";
import { connect } from "react-redux";
import { Dispatch, bindActionCreators, compose } from "redux";

import teacherApi from "actions/teacher";
import ModalWindow from "components/ModalWindow/ModalWindow";
import NoData from "components/NoData/NoData";

export interface GradingInstructionsOverviewModalProps {
	gradingInstruction: any;
	open: boolean;
	closeModal: () => void;
	fetchTeacherGradingInstructions: (challengeId: number) => void;
	unit: any;
}

function GradingInstructionsOverviewModal({ gradingInstruction, open, closeModal, fetchTeacherGradingInstructions, unit }: Readonly<GradingInstructionsOverviewModalProps>) {
	const intl = useIntl();
	useEffect(() => {
		if (open && unit?.id !== null) {
			fetchTeacherGradingInstructions(unit?.id);
		}
	}, []);

	return (
		<ModalWindow
			open={open}
			onClose={closeModal}
			title={intl.fm("teacher.grading.instructions")}
			fullWidth
			maxWidth={"md"}
		>
			{gradingInstruction?.content ? <StyledMarkdown source={gradingInstruction.content} /> : <NoData />}
		</ModalWindow>
	);
}

const mapStateToProps = (state: any, ownProps: GradingInstructionsOverviewModalProps) => ({
	gradingInstruction: state.api.resources.teacherGradingInstruction.data
		.find((instruction: any) => instruction.id === ownProps.unit?.id),
});

const mapDispatchToProps = (dispatch: Dispatch) =>
	bindActionCreators(
		{ fetchTeacherGradingInstructions: teacherApi.fetchTeacherGradingInstructions },
		dispatch,
	);

export default compose(
	connect(
		mapStateToProps,
		mapDispatchToProps,
	),
)(GradingInstructionsOverviewModal);
